//#region src/variants/variants_hovercard.js
var variants_hovercard_default = { default: {
	props: {
		open: { initialValue: false },
		placement: { initialValue: "bottom" }
	},
	slots: {
		anchor: { initialValue: "<dt-button importance=\"outlined\" kind=\"muted\">Hover over me</dt-button>" },
		content: { initialValue: "Hovercard content" }
	}
} };
//#endregion
export { variants_hovercard_default as default };

//# sourceMappingURL=variants_hovercard.js.map